import type { OptionType } from 'Components/MultiSelect/MultiSelect'
import { useAuthorityContext } from 'Services/common/Features/Authority/Context/authorityContext'
import type { TicketSaleReportParamShape } from 'Services/SalesManagement/Features/Report/reportSlice'
import { useGetAllTicketSaleTargetsQuery } from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'
import { useState } from 'react'

export function useBaseTicketSaleReport() {
  const { authorities } = useAuthorityContext()
  const { data: ticketSaleTargets, isFetching: isTicketSaleTargetsFetching } =
    useGetAllTicketSaleTargetsQuery({
      disable_pagination: true
    })

  const [params, setParams] = useState<TicketSaleReportParamShape>({
    authorities: [],
    targets: [],
    from_date: '',
    to_date: ''
  })

  const authorityOptions: OptionType[] =
    authorities?.map(authority => [authority.code, authority.name]) ?? []

  const ticketSaleTargetOptions: OptionType[] =
    ticketSaleTargets?.map(target => [target.id, target.identifier]) ?? []

  return {
    params,
    setParams,
    authorityOptions,
    ticketSaleTargetOptions,
    isTicketSaleTargetsFetching
  }
}
